// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import get from 'lodash/get'
import omit from 'lodash/omit'
import orderBy from 'lodash/orderBy'
import sort from 'lodash/sortBy'
import uniqBy from 'lodash/uniqBy'
import moment from 'moment'
import React from 'react'
import { Mutation, Query } from 'react-apollo'
import { Trans } from 'react-i18next'
import CheckBox from '../../common/checkBox/CheckBox'
import withConfirmModal from '../../common/confirmModal/withConfirmModal'
import withDate from '../../common/date/withDate'
import Loader from '../../common/loader/Loader'
import { MultiSelect } from '../../common/select/Select'
import SnackBar from '../../common/snackBar/SnackBar'
import { markFirstActivityOfEmployees, usersToOptions } from '../../common/utils'
import type { User } from '../admin/users/userTypes'
import { RestrictedConsumer } from '../auth/RestrictedContext'
import withUser from '../auth/withUser'
import { i18n } from '../index'
import withActiveStation, { WithActiveStationProps } from '../station/withActiveStation'
import EmployeeTable from './EmployeeTable'
import css from './StaffingPlan.css'
import { createStaffingPlan, getStaffingPlan, importStaffingPlan } from './staffingPlanQueries'
import type { StaffMember } from './types'

const DATE_FORMAT = 'YYYY-MM-DD'
const RESPONSIBILITIES = {
  WC: 'WC',
  VITRINE: 'Vitrine',
  BUFFET: 'Buffet',
  HALL: 'Hall',
  DISHES: 'Dishes',
  SHIFT_MANAGER: 'ShiftManager',
  MUUT: 'Other',
}
const POSITIONS = {
  ABCBURGER: 'ABCBurger',
  ASPA: 'ASPA',
  MANAGER: 'Manager',
  TRAINEE: 'Trainee',
  TRAINING: 'Training',
  HESBURGER: 'Hesburger',
  FILLING: 'Filling',
  INVENTORY: 'Inventory',
  CASHIER: 'Cashier',
  KITCHEN: 'Kitchen',
  EDUCATION: 'Education',
  MARKET: 'Market',
  MEETING: 'Meeting',
  GAUGECOURT: 'GaugeCourt',
  INTRODUCTION: 'Introduction',
  HALL: 'Hall',
  CLEANING: 'Cleaning',
  DISHES: 'Dishes',
  OFFICE: 'Office',
  VITRINE: 'Vitrine',
  NIGHT: 'Night',
  OTHER: 'Other',
  ABCMEETING: 'ABCMeeting',
  ABCINTRODUCTION: 'ABCIntroduction',
  ABCTRAINEE: 'ABCTrainee',
  ABCOTHERWORKNOTEFFECTIVE: 'ABCOtherWorkNotEffective',
  VASUHALL: 'VASUHall',
  ASPAHALL: 'ASPAHall',
  PRODUCTIONKITCHEN: 'ProductionKitchen',
  VASUKITCHEN: 'VASUKitchen',
  WORKOTHERTASKS: 'WorkOtherTasks',
}
export const positionOptions = [
  {
    label: POSITIONS.ABCBURGER,
    value: POSITIONS.ABCBURGER,
  },
  {
    label: POSITIONS.ASPA,
    value: POSITIONS.ASPA,
  },
  {
    label: POSITIONS.MANAGER,
    value: POSITIONS.MANAGER,
  },
  {
    label: POSITIONS.TRAINEE,
    value: POSITIONS.TRAINEE,
  },
  {
    label: POSITIONS.TRAINING,
    value: POSITIONS.TRAINING,
  },
  {
    label: POSITIONS.HESBURGER,
    value: POSITIONS.HESBURGER,
  },
  {
    label: POSITIONS.FILLING,
    value: POSITIONS.FILLING,
  },
  {
    label: POSITIONS.INVENTORY,
    value: POSITIONS.INVENTORY,
  },
  {
    label: POSITIONS.CASHIER,
    value: POSITIONS.CASHIER,
  },
  {
    label: POSITIONS.KITCHEN,
    value: POSITIONS.KITCHEN,
  },
  {
    label: POSITIONS.EDUCATION,
    value: POSITIONS.EDUCATION,
  },
  {
    label: POSITIONS.MARKET,
    value: POSITIONS.MARKET,
  },
  {
    label: POSITIONS.MEETING,
    value: POSITIONS.MEETING,
  },
  {
    label: POSITIONS.GAUGECOURT,
    value: POSITIONS.GAUGECOURT,
  },
  {
    label: POSITIONS.INTRODUCTION,
    value: POSITIONS.INTRODUCTION,
  },
  {
    label: POSITIONS.HALL,
    value: POSITIONS.HALL,
  },
  {
    label: POSITIONS.CLEANING,
    value: POSITIONS.CLEANING,
  },
  {
    label: POSITIONS.DISHES,
    value: POSITIONS.DISHES,
  },
  {
    label: POSITIONS.OFFICE,
    value: POSITIONS.OFFICE,
  },
  {
    label: POSITIONS.VITRINE,
    value: POSITIONS.VITRINE,
  },
  {
    label: POSITIONS.NIGHT,
    value: POSITIONS.NIGHT,
  },
  {
    label: POSITIONS.ABCMEETING,
    value: POSITIONS.ABCMEETING,
  },
  {
    label: POSITIONS.ABCINTRODUCTION,
    value: POSITIONS.ABCINTRODUCTION,
  },
  {
    label: POSITIONS.ABCTRAINEE,
    value: POSITIONS.ABCTRAINEE,
  },
  {
    label: POSITIONS.ABCOTHERWORKNOTEFFECTIVE,
    value: POSITIONS.ABCOTHERWORKNOTEFFECTIVE,
  },
  {
    label: POSITIONS.VASUHALL,
    value: POSITIONS.VASUHALL,
  },
  {
    label: POSITIONS.VASUKITCHEN,
    value: POSITIONS.VASUKITCHEN,
  },
  {
    label: POSITIONS.ASPAHALL,
    value: POSITIONS.ASPAHALL,
  },
  {
    label: POSITIONS.PRODUCTIONKITCHEN,
    value: POSITIONS.PRODUCTIONKITCHEN,
  },
  {
    label: POSITIONS.WORKOTHERTASKS,
    value: POSITIONS.WORKOTHERTASKS,
  },
  {
    label: POSITIONS.OTHER,
    value: POSITIONS.OTHER,
  },
]
const responsibilityOptions = [
  {
    label: RESPONSIBILITIES.MUUT,
    value: RESPONSIBILITIES.MUUT,
  },
  {
    label: RESPONSIBILITIES.WC,
    value: RESPONSIBILITIES.WC,
  },
  {
    label: RESPONSIBILITIES.VITRINE,
    value: RESPONSIBILITIES.VITRINE,
  },
  {
    label: RESPONSIBILITIES.BUFFET,
    value: RESPONSIBILITIES.BUFFET,
  },
  {
    label: RESPONSIBILITIES.HALL,
    value: RESPONSIBILITIES.HALL,
  },
  {
    label: RESPONSIBILITIES.DISHES,
    value: RESPONSIBILITIES.DISHES,
  },
]
const timeFormat = 'HH:mm'
const SORT_ORDERS = {
  NAME: 'name',
  TIME: 'time',
  POSITION: 'position',
  NONE: '',
}

const sortBy = (employees: Array<StaffMember>, sortCol: string, sortDirection: string) => {
  const employeesToSort = [...employees]
  return employeesToSort.sort(function (a, b) {
    let nameA
    let nameB

    switch (sortCol) {
      case 'Time':
        nameA = a.startTime
        nameB = b.startTime
        break

      case 'Position':
        nameA = i18n.t(`staffingPlan.positions.${a.position}`)
        nameB = i18n.t(`staffingPlan.positions.${b.position}`)
        break

      default:
        nameA = a.user.name.toUpperCase()
        nameB = b.user.name.toUpperCase()
    }

    if (nameA < nameB) {
      return sortDirection === 'ASC' ? -1 : 1
    }

    if (nameA > nameB) {
      return sortDirection === 'ASC' ? 1 : -1
    }

    return 0
  })
}

const composableSort = (
  employees: Array<StaffMember>,
  sortInfo: Array<{
    col: string
    direction: string
  }>,
) => {
  return orderBy(
    employees,
    sortInfo.map((info) => info.col),
    sortInfo.map((info) => info.direction.toLowerCase()),
  )
}

const isToday = (date: string) => {
  const today = moment().format(DATE_FORMAT)
  return today === date
}
type SelectValues = {
  value: string
  label: string
}
type Props = {
  date: string
  isInThePast: boolean
  user: User
  chainIncentiveSalesTarget: number
  incentiveSalesTargetSum: number | null
} & WithActiveStationProps
type State = {
  employees: Array<User>
  selectedEmployees: Array<StaffMember>
  noteIDs: Array<string>
  stationId: string
  sortInfo: Array<{
    col: string
    direction: string
  }>
  sortingComposable: boolean
  showSnackBar: boolean
  isEditable: boolean
  employeesSelectValues: Array<SelectValues>
  isImportingfromElli: boolean
  isOverrideSubmit: boolean
}

@withDate()
@withActiveStation
@withUser
class StaffingPlan extends React.Component<Props, State> {
  state = {
    employees: [],
    selectedEmployees: [],
    employeesSelectValues: [],
    noteIDs: [],
    stationId: '',
    sortInfo: [
      {
        col: 'Name',
        direction: 'DESC',
      },
    ],
    showSnackBar: false,
    isEditable: false,
    sortingComposable: true,
    isImportingfromElli: false,
    isOverrideSubmit: false,
  }
  closeSnackBar = () => {
    this.setState({
      showSnackBar: false,
    })
  }
  toggleSortColumn = (col: string) => {
    const { selectedEmployees, sortingComposable } = this.state
    let sortInfo = this.state.sortInfo

    if (sortingComposable) {
      if (sortInfo.find((info) => info.col === col)) {
        sortInfo = sortInfo.filter((info) => info.col !== col)
      } else {
        sortInfo.push({
          col,
          direction: 'ASC',
        })
      }
    } else {
      if (sortInfo.length === 1 && sortInfo[0].col === col) {
        sortInfo = [
          {
            col: 'user.name',
            direction: 'ASC',
          },
        ]
      } else {
        sortInfo = [
          {
            col,
            direction: 'ASC',
          },
        ]
      }
    }

    this.setState({
      sortInfo,
      selectedEmployees: composableSort(selectedEmployees, sortInfo),
    })
  }
  toggleSortDirection = (col: string) => {
    const { selectedEmployees } = this.state
    const sortInfo = this.state.sortInfo
    const info = sortInfo.find((info) => info.col === col)

    if (info) {
      const index = sortInfo.findIndex((info) => info.col === col)

      if (info.direction === 'ASC') {
        sortInfo[index]['direction'] = 'DESC'
      } else {
        sortInfo[index]['direction'] = 'ASC'
      }
    }

    this.setState({
      sortInfo,
      selectedEmployees: composableSort(selectedEmployees, sortInfo),
    })
  }
  toggleSortingMode = () => {
    const { sortingComposable, selectedEmployees } = this.state
    const sortInfo = [
      {
        col: 'user.name',
        direction: 'ASC',
      },
    ]
    this.setState({
      sortingComposable: !sortingComposable,
      sortInfo,
      selectedEmployees: composableSort(selectedEmployees, sortInfo),
    })
  }
  onSelectionChange = (employeesToAdd: Array<SelectValues>) => {
    const { selectedEmployees } = this.state
    const addedEmployees = []
    employeesToAdd.forEach((item) => {
      const selectedUsers = selectedEmployees.filter((user) => user.userId === item.value)

      if (selectedUsers.length) {
        selectedUsers.forEach((selectedUser) => {
          const employee = {
            userId: item.value,
            user: {
              name: item.label,
            },
            startTime: selectedUser.startTime,
            endTime: selectedUser.endTime,
            position: selectedUser.position,
            responsibility: selectedUser.responsibility,
            salesIncentiveTarget: selectedUser.salesIncentiveTarget,
            thumbsUpTarget: selectedUser.thumbsUpTarget,
            salesIncentiveActual: selectedUser.salesIncentiveActual,
            thumbsUpActual: selectedUser.thumbsUpActual,
            note: selectedUser.note,
          }
          addedEmployees.push(employee)
        })
      } else {
        const employee = {
          userId: item.value,
          user: {
            name: item.label,
          },
          startTime: '06:00',
          endTime: '13:30',
          position: POSITIONS.OTHER,
          responsibility: ['Other'],
          salesIncentiveTarget: 0,
          thumbsUpTarget: 0,
          salesIncentiveActual: 0,
          thumbsUpActual: 0,
          note: '',
        }
        addedEmployees.push(employee)
      }
    })
    this.setState({
      selectedEmployees: sortBy(markFirstActivityOfEmployees([...addedEmployees]), 'Name', 'ASC'),
      employeesSelectValues: uniqBy([...employeesToAdd], 'value'),
    })
  }
  updateEmployees = (employees: Array<StaffMember>) => {
    const preselectedEmployees = [...employees].map((employee) => {
      return {
        label: employee.user.name,
        value: employee.userId,
      }
    })
    this.setState({
      selectedEmployees: sortBy([...employees], 'Name', 'ASC'),
      employeesSelectValues: uniqBy([...preselectedEmployees], 'value'),
    })
  }
  onUpdate = (onMutate: (...args: Array<any>) => any) => {
    this.props.confirmModal.show(i18n.t('staffingPlan.importFromElliWarning'), async (isConfirmed: boolean) => {
      if (isConfirmed) {
        this.setState({
          isImportingfromElli: true,
        })
        const updatedStaffingPlan = await onMutate()
        const roster = get(updatedStaffingPlan, 'data.importStaffingPlan.roster', [])
        const updatedEmployees = markFirstActivityOfEmployees(
          [...roster].map(
            ({
              user,
              startTime,
              endTime,
              startDateTime,
              endDateTime,
              position,
              responsibility,
              salesIncentiveTarget,
              thumbsUpTarget,
              salesIncentiveActual,
              thumbsUpActual,
              note,
            }) => ({
              userId: user.id,
              user: {
                name: user.name,
              },
              startTime,
              endTime,
              startDateTime,
              endDateTime,
              position,
              responsibility,
              salesIncentiveTarget,
              thumbsUpTarget,
              salesIncentiveActual,
              thumbsUpActual,
              note,
            }),
          ),
        )
        this.setState({
          isImportingfromElli: false,
          selectedEmployees: [...updatedEmployees],
        })
      }
    })
  }
  onSubmit = async (onMutate: (...args: Array<any>) => any) => {
    const { selectedEmployees, stationId, isEditable, isOverrideSubmit } = this.state
    const { date } = this.props
    const filteredEmployees = [...selectedEmployees].map((employee) =>
      omit(employee, ['user', '__typename', 'thumbsUpActual', 'salesIncentiveActual', 'isFirstActivity']),
    )

    if (isEditable || isOverrideSubmit) {
      try {
        const data = {
          roster: [...filteredEmployees],
          date,
        }
        const createdStaffingPlan = await onMutate({
          variables: {
            stationId,
            data,
          },
        })
        const {
          data: {
            createStaffingPlan: { roster },
          },
        } = createdStaffingPlan
        const updatedEmployees = markFirstActivityOfEmployees(
          [...roster].map(
            ({
              user,
              startTime,
              endTime,
              position,
              responsibility,
              salesIncentiveTarget,
              thumbsUpTarget,
              salesIncentiveActual,
              thumbsUpActual,
              note,
              breaks,
            }) => ({
              userId: user.id,
              user: {
                name: user.name,
              },
              startTime,
              endTime,
              position,
              responsibility,
              salesIncentiveTarget,
              thumbsUpTarget,
              salesIncentiveActual,
              thumbsUpActual,
              note,
              breaks,
            }),
          ),
        )
        this.setState({
          isEditable: false,
          selectedEmployees: [...updatedEmployees],
          isOverrideSubmit: false,
        })
      } catch (error) {
        // TODO: do something if submission process failed
      }
    } else {
      this.setState({
        isEditable: true,
      })
    }
  }
  onCancel = () => {
    this.setState({
      isEditable: false,
    })
  }
  toggleEditNote = (uniqID: string) => {
    const { noteIDs } = this.state
    const index = noteIDs.findIndex((item) => item === uniqID)

    if (noteIDs.find((item) => item === uniqID)) {
      noteIDs.splice(index, 1)
    } else {
      noteIDs.push(uniqID)
    }

    this.setState({
      noteIDs,
    })
  }
  removeStaffMember = (userId: string, idx: number) => {
    const { selectedEmployees, employeesSelectValues } = this.state
    const employees = [...selectedEmployees]
    const updateMultiselectValues = [...employeesSelectValues]
    employees.splice(idx, 1)
    const employeeRows = employees.filter((employee) => employee.userId === userId)

    if (!employeeRows.length) {
      const selectIndex = employeesSelectValues.findIndex((item) => item.value === userId)
      updateMultiselectValues.splice(selectIndex, 1)
    }

    this.setState({
      selectedEmployees: [...employees],
      employeesSelectValues: uniqBy([...updateMultiselectValues], 'value'),
    })
  }

  componentDidMount() {
    const { activeStation } = this.props
    const { selectedEmployees } = this.state
    const users = activeStation.users || []
    this.setState({
      employees: users,
      stationId: activeStation.id || '',
      isEditable: selectedEmployees.length > 0,
    })
  }

  overrideSubmit = (onMutate: (...args: Array<any>) => any) => {
    this.setState(
      {
        isOverrideSubmit: true,
      },
      () => this.onSubmit(onMutate),
    )
  }

  render() {
    const {
      selectedEmployees,
      employees,
      stationId,
      showSnackBar,
      isEditable,
      sortInfo,
      employeesSelectValues,
      sortingComposable,
      isImportingfromElli,
    } = this.state
    const { user, date, isInThePast, chainIncentiveSalesTarget, incentiveSalesTargetSum } = this.props
    return (
      <Mutation
        mutation={createStaffingPlan}
        refetchQueries={() => [
          {
            query: getStaffingPlan,
            variables: {
              stationId,
              date,
              mode: 'Day',
            },
            skip: !stationId || !date,
          },
        ]}
      >
        {(onMutate) => (
          <RestrictedConsumer>
            {(hasPermission) => (
              <div className={css.component}>
                {isImportingfromElli && (
                  <div className={css.importFromElliLoader}>
                    <CircularProgress></CircularProgress>
                  </div>
                )}
                {hasPermission &&
                  isEditable &&
                  isToday(date) &&
                  (employees.length > 0 ? (
                    <MultiSelect
                      className={css.select}
                      placeholder={i18n.t('staffingPlan.selectPlaceholder')}
                      options={sort(usersToOptions(employees), (option) => option.label.toUpperCase())}
                      isMulti
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      isSearchable={true}
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      noOptionsMessage={() => {
                        return i18n.t('staffingPlan.noEmployees')
                      }}
                      onChange={this.onSelectionChange}
                      value={employeesSelectValues}
                    />
                  ) : (
                    <Typography variant='h6' className={css.noEmployeesMessage}>
                      <Trans
                        i18nKey='staffingPlan.addEmployeesToStation'
                        components={{ lnk: <a href='/yllapito/toimipaikat' /> }}
                      />
                    </Typography>
                  ))}
                <Query
                  query={getStaffingPlan}
                  variables={{
                    stationId,
                    date,
                    mode: 'Day',
                  }}
                  skip={!stationId || !date}
                  fetchPolicy='network-only'
                >
                  {({ loading, error, data, refetch }) => {
                    const totalIncentiveSalesTarget = selectedEmployees.reduce(
                      (sum, employee) => sum + (employee.salesIncentiveTarget || 0),
                      0,
                    )
                    const isValid =
                      incentiveSalesTargetSum !== null && totalIncentiveSalesTarget === incentiveSalesTargetSum
                    return (
                      <Loader
                        {...{
                          loading,
                          error,
                        }}
                      >
                        <div className={css.checkboxContainer}>
                          <CheckBox
                            checked={sortingComposable}
                            label={i18n.t('staffingPlan.multiColumnSorting')}
                            onChange={this.toggleSortingMode}
                          />
                        </div>
                        <EmployeeTable
                          data={get(data, 'staffPlan.roster', {})}
                          updateEmployees={(selectedEmployees) => this.updateEmployees(selectedEmployees)}
                          isEditable={isEditable}
                          employees={selectedEmployees}
                          removeStaffMember={this.removeStaffMember}
                          sortInfo={sortInfo}
                          toggleSortColumn={this.toggleSortColumn}
                          toggleSortDirection={this.toggleSortDirection}
                          toggleEditNote={this.toggleEditNote}
                          noteIDs={this.state.noteIDs}
                          stationId={stationId}
                          date={date}
                          isToday={isToday(date)}
                          shiftResponsibilities={get(data, 'availableShiftResponsibilities', [])}
                          activityDescriptions={get(data, 'stationActivityDescriptions', [])}
                          submit={() => this.overrideSubmit(onMutate)}
                          totalIncentivesTarget={get(data, 'staffPlan.totalIncentivesTarget', null)}
                          totalThumbablesTarget={get(data, 'staffPlan.totalThumbablesTarget', null)}
                          chainIncentiveSalesTarget={chainIncentiveSalesTarget}
                          incentiveSalesTargetSum={incentiveSalesTargetSum}
                        />
                        <div className={css.actions}>
                          <Button
                            className={css.buttoncancel + ' staffing-plan-cancel-edit'}
                            style={
                              !isEditable
                                ? {
                                    display: 'none',
                                  }
                                : {}
                            }
                            onClick={() => {
                              refetch()
                              this.onCancel()
                            }}
                          >
                            {i18n.t('buttons.cancel')}
                          </Button>
                          {!isEditable && !isInThePast && (
                            <Mutation
                              mutation={importStaffingPlan}
                              variables={{
                                stationId,
                                date,
                              }}
                            >
                              {(onMutate) => (
                                <Button
                                  className={css.buttonupdate}
                                  color='primary'
                                  variant='contained'
                                  onClick={() => {
                                    this.onUpdate(onMutate)
                                  }}
                                >
                                  {i18n.t('staffingPlan.updateFromElli')}
                                </Button>
                              )}
                            </Mutation>
                          )}
                          <Button
                            disabled={isInThePast || (isEditable && !isValid)}
                            color='primary'
                            variant='contained'
                            onClick={() => this.onSubmit(onMutate)}
                          >
                            {i18n.t(isEditable ? 'buttons.save' : 'buttons.edit')}
                          </Button>
                        </div>
                      </Loader>
                    )
                  }}
                </Query>
                <SnackBar
                  closeSnackBar={this.closeSnackBar}
                  showSnackBar={showSnackBar}
                  message={i18n.t('staffingPlan.employeeAlreadyAdded')}
                />
              </div>
            )}
          </RestrictedConsumer>
        )}
      </Mutation>
    )
  }
}

export default withConfirmModal(StaffingPlan, {
  okButtonClass: 'btn-error',
})
